const discountsStrings = {
  pageTitle: 'All Discounts',
  createOfferBtn: 'Create Offer',
  createBundleBtn: 'Create Bundle',
  filtersBtn: 'Filters',
  advancedFiltersTitle: 'Advanced Filters',
  statusPlaceholder: 'Status',
  applyBtn: 'Apply',
  exploreByLabel: 'Explore by',
  stockFilterLabel: 'Stock',
  statusAll: 'All',
  statusActive: 'Running',
  statusScheduled: 'Upcoming',
  statusStopped: 'Stopped',
  statusCompleted: 'Completed',
  itemTypeLabel: 'Item Type',
  itemTypeAll: 'All',
  itemTypeProduct: 'Offer',
  itemTypeBundle: 'Bundle',
  stockAll: 'All',
  stockInStock: 'In Stock',
  stockOutOfStock: 'Out of Stock',
  emptyList: 'No discounts found',
  noOffersTitle: 'No Offers Yet',
  noOffersSubtitle: 'You need to create offers to see them here.',
  loadError: 'Something went wrong while loading discounts',
  endsInLabel: 'Ends in',
  endedOnLabel: 'Ended on',
  currency: 'EGP',
  actionStopOffer: 'Stop Offer',
  actionStopPublishing: 'Stop Publishing',
  actionEditOffer: 'Edit Offer',
  actionRepublishOffer: 'Republish this offer',
  cancelBtn: 'Cancel',
  clearBtn: 'Clear',
  saveBtn: 'Save',
  selectBtn: 'Select',
  saveEditsBtn: 'Save Edits',
  selectProductsTitle: 'Select Products',
  createDiscountTitle: 'Create Discount',
  editOfferTitle: 'Edit Offer',
  searchResultsLabel: 'Search Results',
  productsAddedLabel: (count: number) => `${count} Products Added`,
  selectProductsMultipleLabel: 'Select Products Multiple',
  selectProductsBtn: 'Select Products',
  productsSummaryLabel: 'Products Summary',
  statusColumnLabel: 'Status',
  originalPriceLabel: 'Original Price',
  discountColumnLabel: 'Discount',
  actionsColumnLabel: 'Actions',
  discountPercentagePlaceholder: 'Discount Percentage',
  showAllLabel: (count: number) => `Show All (${count})`,
  createOfferSubmitBtn: 'Create Offer',
  createBundleTitle: 'Create Bundle',
  createBundleSubmitBtn: 'Create Bundle Offer',
  selectBundleLabel: 'Select Bundle',
  selectBundleTitle: 'Select Bundle',
  selectBundleBtn: 'Select Bundle',
  searchBundlePlaceholder: 'Search bundle name...',
  addBundleBtn: 'Add',
  changeBundleBtn: 'Change',
  bundleDescriptionLabel: 'Description',
  discountTypeLabel: 'Discount Type',
  discountAmountPlaceholder: 'Discount Amount',
  bundleLabel: 'Bundle',
  discountInfoBanner:
    'The discount amount or percentage will still apply if the original price is updated later.',
  fromLabel: 'From',
  toLabel: 'To',
  originalPriceFieldLabel: 'Original Price',
  discountFieldLabel: 'Discount',
  loadMore: 'Load More',
  searchProductsPlaceholder: 'Search products',
  validationRequired: 'This field is required',
  validationStartDateBeforeToday: 'Start date cannot be before today',
  validationEndDateAfterStart: 'End date must be after start date',
  validationNegativeDiscount: 'Discount must be greater than 0',
  validationPercentMax: 'Percentage cannot exceed 100',
  validationAmountExceedsPrice: 'Discount cannot exceed item price',
  createSuccess: 'Your discount has been created.',
  updateSuccess: 'Your discount has been updated.',
  actionError: 'Something went wrong. Please try again.',
  confirmStopOfferTitle: 'Stop Offer',
  confirmStopOfferMessage: 'Are you sure you want to stop this offer?',
  confirmStopPublishingTitle: 'Stop Publishing',
  confirmStopPublishingMessage: 'Are you sure you want to stop publishing this offer?',
};

export default discountsStrings;
